module.exports = __webpack_public_path__ + "static/LOGO_PEF-1d60f4027c1c6c6b0d12d4beb55a8291.png";